// extracted by mini-css-extract-plugin
module.exports = {"blockButtonOnMobile":"style-module__blockButtonOnMobile___22-8l"};